export default __webpack_public_path__ + "d66a62e82287b864947c864da2efaf94.woff2";